export const initialValues = {
  year: "",
  box: "",
  condition: "",
  source: "",
  location: "",
  priceSortBy: "",
};
